import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Idea Management Software | Canny';
const Description =
  "Product idea management the easy way! Canny's idea management software helps you capture, track, manage, and analyze your ideas. Get started for free!";
const Image = 'https://canny.io/images/canny-social.png';
const IdeaManagementUrl = 'https://canny.io/use-cases/idea-management';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${IdeaManagementUrl}#webpage`,
    url: IdeaManagementUrl,
    name: 'Idea Management - Canny',
    description:
      "Capture, organize, and prioritize ideas with Canny's idea management software to turn customer input into actionable product decisions.",
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${IdeaManagementUrl}#capabilities`,
    'Idea Management Capabilities',
    [
      {
        name: 'Collect Ideas from Multiple Sources',
        description:
          'Capture ideas through feedback boards, integrations, and in-app submissions to centralize innovation.',
      },
      {
        name: 'Organize and Evaluate Ideas',
        description:
          'Use tagging, segmentation, and prioritization tools to evaluate ideas based on impact and feasibility.',
      },
      {
        name: 'Prioritize High-Impact Initiatives',
        description:
          'Rank ideas by votes, customer value, and strategic alignment to focus on the most impactful work.',
      },
      {
        name: 'Close the Loop with Stakeholders',
        description:
          'Communicate progress and updates back to users to show their ideas drive product improvements.',
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Use Cases', item: 'https://canny.io/use-cases' },
    { name: 'Idea Management', item: IdeaManagementUrl },
  ]),
]);

export default class LandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: IdeaManagementUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
